(function () {
  function init() {
    if (document.body) document.body.classList.add('rv-active');

    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) {
      // Reveal everything immediately for users who don't want motion
      document.querySelectorAll('.js-reveal').forEach(function (el) { el.classList.add('in-view'); });
      return;
    }

    document.documentElement.classList.add('js-motion');

    var ingredients = document.querySelectorAll('.rv-ingredient');
    ingredients.forEach(function (el, i) {
      el.classList.add('js-reveal');
      el.dataset.revealDelay = String((i % 4) * 80 + Math.floor(i / 4) * 120);
    });

    var revealables = document.querySelectorAll('.js-reveal');
    revealables.forEach(function (el) {
      var d = parseInt(el.dataset.revealDelay || '0', 10);
      if (d > 0) el.style.transitionDelay = d + 'ms';
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

      revealables.forEach(function (el) { io.observe(el); });
    } else {
      revealables.forEach(function (el) { el.classList.add('in-view'); });
    }

    // Long-tail safety net (only fires if user is idle for 30s without scrolling)
    setTimeout(function () {
      document.querySelectorAll('.js-reveal:not(.in-view)').forEach(function (el) {
        el.classList.add('in-view');
      });
    }, 30000);

    // Subtle parallax on the hero product photo
    var heroPhoto = document.querySelector('.rv-hero-photo-frame');
    if (heroPhoto && window.requestAnimationFrame) {
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (!ticking) {
          window.requestAnimationFrame(function () {
            var y = window.scrollY;
            var translate = Math.max(-30, Math.min(0, -y * 0.04));
            heroPhoto.style.transform = 'translateY(' + translate + 'px)';
            ticking = false;
          });
          ticking = true;
        }
      }, { passive: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
